import type { TransferTarget, TransferType } from 'Modules/softphone/types/transfer.types';

export const VOICEMAIL_NOT_ENABLED_HELPER_TEXT =
  'Voicemail is not enabled for this user';

/**
 * Returns the helper text explaining why a disabled transfer option is
 * unavailable, or `null` when no explanation is needed.
 *
 * Per the acceptance criteria (FR3/FR10) and bug CUU2-3409: when the
 * "Transfer to voicemail" option is disabled the UI must explain that the
 * target user does not have voicemail enabled.
 */
export function getTransferOptionHelperText(
  option: TransferType,
  target: TransferTarget | null,
  selectedPhoneNumber: string | null
): string | null {
  if (!target || !selectedPhoneNumber) {
    return null;
  }

  if (option !== 'voicemail') {
    return null;
  }

  return VOICEMAIL_NOT_ENABLED_HELPER_TEXT;
}
